import { LANGUAGES } from '@savgroup-front-common/constants';
import { miniLanguageCode } from '@savgroup-front-common/core/helpers';

const ADYEN_DEFAULT_LOCALE = 'en-US';

const ADYEN_LOCALE_BY_LANGUAGE: Partial<Record<LANGUAGES, string>> = {
  [LANGUAGES.FR]: 'fr-FR',
  [LANGUAGES.EN]: 'en-US',
  [LANGUAGES.DE]: 'de-DE',
  [LANGUAGES.ES]: 'es-ES',
  [LANGUAGES.IT]: 'it-IT',
  [LANGUAGES.PT]: 'pt-PT',
  [LANGUAGES.NL]: 'nl-NL',
};

export const adaptLanguageToAdyenLocale = ({
  language,
}: {
  language: string;
}): string => {
  return (
    ADYEN_LOCALE_BY_LANGUAGE[miniLanguageCode(language)] ?? ADYEN_DEFAULT_LOCALE
  );
};
